/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { IInspectionRecordGroup } from "pages/thermography/model/inspection-record-group.model";
import { TreeAdapter } from "../../../components/InspectionRouteTree/mappers/genericTreeMapper";
import { IInspectionRecordGroupEquipment } from "pages/thermography/model/inspection-record-group-equipment.model";
import { EquipmentInspectionStatus } from "../../utils/enumEquipmentInspectionStatus";
import { TreeNodeType } from "pages/thermography/components/InspectionRouteTree/types/treeNode";

export const inspectionRecordAdapter: TreeAdapter<IInspectionRecordGroup, IInspectionRecordGroupEquipment> = {
    getId: g => g.id ?? undefined,
    getName: g => g.name ?? null,
    getCode: g => g.code ?? null,
    getIncluded: () => true,
    getOrderIndex: g => g.orderIndex ?? 0,

    getSubGroups: g => g.subGroups ?? [],
    getEquipments: g => g.equipments ?? [],

    getEquipmentOrder: eq => eq.orderIndex ?? 0,

    equipmentToNode: (eq, parentId) => {
        const anomalies = (eq as any).anomalyRecords ?? [];

        const anomalyNodes = anomalies.map((a: any, index: number) => ({
            id: a.id ?? `anomaly-${eq.id}-${index}`,
            type: TreeNodeType.ITEM,
            parentId: eq.id ?? "",

            name: a.equipmentComponentName ?? null,
            code: null,

            title: a.equipmentComponentName,

            condition: a.condition,

            included: true,
            orderIndex: index,
            children: []
        }));

        return {
            id: eq.id ?? "",
            type: TreeNodeType.ELEMENT,
            parentId,
            name: eq.equipment?.name ?? null,
            code: eq.equipment?.code ?? null,
            title:
                eq.equipment?.name && eq.equipment?.code
                    ? `${eq.equipment.name} (${eq.equipment.code})`
                    : eq.equipment?.name ?? eq.equipment?.code ?? "Equipamento",
            status: eq.status,
            included: true,
            orderIndex: eq.orderIndex ?? 0,

            children: anomalyNodes
        };
    }


    // equipmentToNode: (eq, parentId) => ({
    //     id: eq.id ?? "",
    //     type: TreeNodeType.ELEMENT,
    //     parentId,
    //     name: eq.equipment?.name ?? null,
    //     code: eq.equipment?.code ?? null,
    //     title:
    //         eq.equipment?.name && eq.equipment?.code
    //             ? `${eq.equipment.name} (${eq.equipment.code})`
    //             : eq.equipment?.name ?? eq.equipment?.code ?? "Equipamento",
    //     status: eq.status,
    //     included: true,
    //     orderIndex: eq.orderIndex ?? 0,
    //     children: []
    // })
};
